import paper from "paper";
import {SimpleMusicPaperShape} from "@consts/types";
import { AbstractFigure } from './core/abstract-figure'
import convertColorForPaperJS from '../utils/convert-color/convert-color'

export class Rectangle extends AbstractFigure<paper.Path.Rectangle, SimpleMusicPaperShape> {
  protected initCoreFigure(paperScope: paper.PaperScope, shapeData: SimpleMusicPaperShape): paper.Path {
    const { color, shapeScheme: { size, point } } = shapeData;
    const coreShape =  new paper.Path.Rectangle({
      width: size.width,
      height: size.height,
      x: point.x,
      y: point.y
    });

    coreShape.fillColor = convertColorForPaperJS(coreShape, color);
    return coreShape;
  }

  protected updateCoreFigureByShapeData(coreShape: paper.Path.Rectangle, shapeData: SimpleMusicPaperShape) {
    const { color, shapeScheme: { size, point } } = shapeData;

    coreShape.bounds.height = size.height;
    coreShape.bounds.width = size.width;
    coreShape.bounds.x = point.x;
    coreShape.bounds.y = point.y;
    coreShape.fillColor = convertColorForPaperJS(coreShape, color);
  }

  protected serializationToShapeData(coreFigure: paper.Path.Rectangle, shape: SimpleMusicPaperShape): SimpleMusicPaperShape {
    return {
      ...shape,
      shapeScheme: {
        size: {
          width: coreFigure.bounds.width,
          height: coreFigure.bounds.height,
        },
        point: {
          x: coreFigure.bounds.x,
          y: coreFigure.bounds.y,
        }
      }
    }
  }
}
